import React from 'react'
import ScheduledStudioKwIndexDetailList from './ScheduledStudioKwIndexDetailList'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function ScheduledStudioKwIndexDetail() {
	SetTitle('Scheduling')
	return (
		<Header
			iconClass="fa-solid fa-chart-line fa-xl"
			title="Scheduling Index"
		>
			<ScheduledStudioKwIndexDetailList />
		</Header>
	)
}